import type { Action } from 'redux';
import { type Channel } from 'redux-saga';
import {
  actionChannel, take,
} from 'redux-saga/effects';
import { logError } from '~/_shared/utils/logError';

export function* logErroneousActions() {
  const errorActionsChannel: Channel<Action> = yield actionChannel(
    (action: Action) => action.type.includes('ERROR')
  );

  while (true) {
    const action: Action = yield take(errorActionsChannel);

    logError('Error action detected:', action);
  }
}
